import { pluralRu } from '@/shared/lib'
import type { Roster } from '../model/schema'

// Сколько имён показывать в строке карточки: три помещаются на мобиле в одну-две
// строки, остальные сворачиваются в счётчик.
const SHOWN = 3

// Счётчик состава словами: смысл числа зависит от того, чей это состав.
export function rosterCountLabel(roster: Roster): string {
  if (roster.total === 0) return ''
  if (roster.kind === 'in_call') return `${roster.total}\u00A0в звонке`
  if (roster.kind === 'invited') {
    return `${roster.total}\u00A0${pluralRu(roster.total, 'приглашён', 'приглашены', 'приглашены')}`
  }
  return `${roster.total}\u00A0${pluralRu(roster.total, 'участник', 'участника', 'участников')}`
}

// Кто на встрече — прямо в карточке списка, без открытия. Полный состав уходит
// в title: строка обрезается, но наведение отвечает целиком.
export function MeetingRoster({ roster }: { roster: Roster }) {
  if (roster.names.length === 0) return null
  const shown = roster.names.slice(0, SHOWN)
  const rest = roster.total - shown.length
  return (
    <p className="truncate text-sm text-text-tertiary" title={roster.names.join(', ')}>
      {shown.join(', ')}
      {rest > 0 && ` и ещё ${rest}`}
    </p>
  )
}
